import { Fragment } from "react";

const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i} className="font-semibold text-bark">{part.slice(2, -2)}</strong>;
    if (/^\*[^*]+\*$/.test(part)) return <em key={i}>{part.slice(1, -1)}</em>;
    return <Fragment key={i}>{part}</Fragment>;
  });

const toBlocks = (text) => {
  const blocks = [];
  for (const raw of (text || "").replace(/\r/g, "").split("\n")) {
    const line = raw.trimEnd();
    const last = blocks[blocks.length - 1];
    if (!line.trim()) blocks.push({ type: "gap" });
    else if (line.startsWith("## ")) blocks.push({ type: "h", text: line.slice(3) });
    else if (/^[-•] /.test(line)) last?.type === "ul" ? last.items.push(line.slice(2)) : blocks.push({ type: "ul", items: [line.slice(2)] });
    else if (last?.type === "p") last.lines.push(line);
    else blocks.push({ type: "p", lines: [line] });
  }
  return blocks.filter((b) => b.type !== "gap");
};

export const stripRichText = (text) =>
  (text || "").replace(/\*\*([^*]+)\*\*/g, "$1").replace(/\*([^*]+)\*/g, "$1").replace(/^(## |[-•] )/gm, "").replace(/\s+/g, " ").trim();

export default function RichText({ text, className = "", testId }) {
  return (
    <div data-testid={testId} className={`space-y-3 text-base leading-relaxed text-bark-soft ${className}`}>
      {toBlocks(text).map((b, i) =>
        b.type === "h" ? <h3 key={i} className="pt-1 font-serif text-lg font-semibold text-bark">{inline(b.text)}</h3>
        : b.type === "ul" ? <ul key={i} className="list-disc space-y-1 pl-5 marker:text-honey">{b.items.map((it, j) => <li key={j}>{inline(it)}</li>)}</ul>
        : <p key={i}>{b.lines.map((l, j) => <Fragment key={j}>{j > 0 && <br />}{inline(l)}</Fragment>)}</p>
      )}
    </div>
  );
}
